import { BlogDataService } from './../../../data/repository/blog-repository/blog-data.service';
import { ActivatedRoute, Params } from '@angular/router';
import { BlogShared } from './../../general/shared/blog-shared';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { BlogService } from 'src/app/data/repository/blog-repository/blog.service';
import { LoadingShared } from 'src/app/presentation/general/shared/loading-shared';
import { BlogUserModel } from 'src/app/core/model/object/blog-user-model';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-follower-following',
  templateUrl: './follower-following.component.html',
  styleUrls: ['./follower-following.component.scss'],
})
export class FollowerFollowingComponent implements OnInit {
  // @Input()
  user: BlogUserModel;
  // @Input()
  id: number = 10;
  // @Input()
  page: number = 0;
  // @Input()
  isMyProfile: boolean = false;

  dataIsReady = false;
  blogUsers: BlogUserModel[];

  usersPage = 0;
  usersCount = 0;
  usersPerPage = 20;

  showProfile = false;
  profileId = 11;
  selectedUsername = '';

  constructor(
    private loadingShared: LoadingShared,
    private blogService: BlogService,
    private snackBarService: SnackBarService,
    private blogShared: BlogShared,
    private route: ActivatedRoute,
    private blogData: BlogDataService
  ) {
    this.id = parseInt(this.route.snapshot.paramMap.get('id'));
    this.user = this.blogData.getUser();
    this.page = this.blogData.getPage();
  }

  ngOnInit() {
    this.load();
  }
  goback() {
    this.blogService.goback();
  }
  load() {
    this.blogUsers = [];
    this.loadingShared.showLoading();
    this.usersPage = 0;
    this.usersCount = 0;
    const el = document.getElementById('hover-tab');
    el.style.right = this.page === 0 ? '0' : '50%';
    if (this.page === 0) {
      this.blogService
        .userFollowers(this.usersPage, this.usersPerPage, this.user.id)
        .then((res) => {
          if (res.isSuccess()) {
            this.blogUsers = res.getData().getBlogList().users;
            this.usersCount = res.getData().getBlogList().count;
            this.dataIsReady = true;
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    } else {
      this.blogService
        .userFollowees(this.usersPage, this.usersPerPage, this.user.id)
        .then((res) => {
          if (res.isSuccess()) {
            this.blogUsers = res.getData().getBlogList().users;
            this.usersCount = res.getData().getBlogList().count;
            this.dataIsReady = true;
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    }
  }

  showMoreUsers() {
    this.loadingShared.showLoading();
    this.usersPage++;
    if (this.page === 0) {
      this.blogService
        .userFollowers(this.usersPage, this.usersPerPage, this.user.id)
        .then((res) => {
          if (res.isSuccess()) {
            this.blogUsers = [
              ...this.blogUsers,
              ...res.getData().getBlogList().users,
            ];
            this.usersCount = res.getData().getBlogList().count;
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    } else {
      this.blogService
        .userFollowees(this.usersPage, this.usersPerPage, this.user.id)
        .then((res) => {
          if (res.isSuccess()) {
            this.blogUsers = [
              ...this.blogUsers,
              ...res.getData().getBlogList().users,
            ];
            this.usersCount = res.getData().getBlogList().count;
          } else {
            this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
          }
          this.loadingShared.hideLoading();
        });
    }
  }

  profile(username: string) {
    this.blogService.goToUserProfile(username);

    // this.selectedUsername = username;
    // this.blogShared.blogZIndex++;
    // this.profileId = this.blogShared.blogZIndex;
    // this.showProfile = true;
    // setTimeout(() => {
    //   document.getElementById('profilePage' + this.id).style.zIndex =
    //     this.blogShared.blogZIndex.toString();
    //   document.getElementById('profilePage' + this.id).style.right = '0';
    // }, 100);
  }

  closeProfile() {
    this.blogShared.blogZIndex--;
    let el = document.getElementById('profilePage' + this.id);
    if (el) el.style.right = '100%';
    // this._sharedService.animateDownButton();
    setTimeout(() => {
      this.showProfile = false;
    }, 300);
  }

  unFollow(user: BlogUserModel) {
    this.blogService.follow(user.id).then((res) => {
      if (res.isSuccess()) {
        this.blogUsers.splice(this.blogUsers.indexOf(user), 1);
        this.blogShared.followedSuggestedUsernames.splice(
          this.blogShared.followedSuggestedUsernames.indexOf(user.userName),
          1
        );
        this.blogShared.pendingSuggestedUsernames.splice(
          this.blogShared.pendingSuggestedUsernames.indexOf(user.userName),
          1
        );
      }
    });
  }

  changePage(page: number) {
    this.page = page;
    this.load();
  }
}
